"use strict";

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var ToolbarButton_1 = __importDefault(require("./ToolbarButton"));

var ToolbarSeparator_1 = __importDefault(require("./ToolbarSeparator"));

var Menu = /*#__PURE__*/function (_React$Component) {
  _inherits(Menu, _React$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    _classCallCheck(this, Menu);

    return _super.apply(this, arguments);
  }

  _createClass(Menu, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          view = _this$props.view,
          items = _this$props.items;
      var state = view.state;
      var Tooltip = this.props.tooltip;
      return React.createElement("div", null, items.map(function (item, index) {
        if (item.name === "separator" && item.visible !== false) {
          return React.createElement(ToolbarSeparator_1.default, {
            key: index
          });
        }

        if (item.visible === false || !item.icon) {
          return null;
        }

        var Icon = item.icon;
        var isActive = item.active ? item.active(state) : false;
        return React.createElement(ToolbarButton_1.default, {
          key: index,
          onClick: function onClick() {
            return item.name && _this.props.commands[item.name](item.attrs);
          },
          active: isActive
        }, React.createElement(Tooltip, {
          tooltip: item.tooltip,
          placement: "top"
        }, React.createElement(Icon, {
          color: _this.props.theme.toolbarItem
        })));
      }));
    }
  }]);

  return Menu;
}(React.Component);

exports.default = styled_components_1.withTheme(Menu);